import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inject Authorization header from localStorage if available (testing/fallback)
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("tonneva_token") : null;
  if (t && t !== "__cookie__") config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
